import {AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild, ViewContainerRef} from '@angular/core';

@Component({
    selector: 'app-dynamic-content',
    template: '<ng-container #dynamicContainer></ng-container>',
})
export class DynamicContentComponent implements AfterViewInit, OnChanges {
    @ViewChild('dynamicContainer', {read: ViewContainerRef}) container!: ViewContainerRef;
    @Input() template: string = '';

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    ngAfterViewInit(): void {
        if (this.template) {
            this.createDynamicComponent(this.template);
        }
    }

    private createDynamicComponent(html: string) {
        this.container.clear();

        const dynamicComponent = Component({template: html})(class {
        });
        const componentRef = this.container.createComponent(dynamicComponent);
    }
}
